import { useColorMode, useColorStyle } from '@tonic-one/react';

const useMenusItemStyle = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const colorModeStyle = (
    {
      light: {
        color: colorStyle.color.emphasis,
        _hover: {
          bg: colorStyle.background.selected,
        },
      },
      dark: {
        color: colorStyle.color.emphasis,
        _hover: {
          bg: colorStyle.background.selected,
        },
      },
    } as any
  )[colorMode];

  return {
    cursor: 'pointer',
    ...colorModeStyle,
  };
};
export { useMenusItemStyle };
